<template>
  <div id="icon-button">
    <button
      class="icon-button__btn"
      :style="btnStyle"
    >
		  <i :class="iconClass" :style="iconStyle"></i>
    </button>
  </div>
</template>

<script>
export default {
  name: "IconButton",
  props: {
    btnStyle: {
      type: Object,
    },
    iconClass: {
      type: String,
      required: true,
    },
    iconStyle: {
      type: Object,
    },
  },
};
</script>

<style lang="scss" scoped>
#icon-button {
	.icon-button {
		&__btn {
			display: block;
			background: transparent;
			border: none;
			z-index: 100;
			appearance: none;
			cursor: pointer;
			outline: none;
		}
	}
}
</style>